import { cn } from "tailwind-variants";
import { useGetSiteSettings } from "#/_packages/umbrella/hooks/useGetSiteSettings.ts";
import { BlockGrid } from "#/_packages/umbrella/integrations/umbraco/property-components/block-grid.tsx";

const getSiteHeaderDivider = (value: string | null | undefined) => {
	switch (value) {
		case "none":
			return "";
		case "content":
			return "site-header-divider-content";
		case "full":
			return "site-header-divider-full";
		default:
			return "";
	}
};

export default function Header() {
	const siteSettings = useGetSiteSettings();

	const siteHeaderVariant =
		siteSettings?.navbarPosition === "sticky" ? "site-header-sticky" : "";
	const siteHeaderDivider = getSiteHeaderDivider(
		siteSettings?.pageHeaderDivider,
	);

	const headerBlocks = siteSettings?.headerContentArea;

	const hasHeaderContent =
		headerBlocks != null && headerBlocks.items.length > 0;

	return hasHeaderContent ? (
		<>
			<div className="sticky-sentinel" aria-hidden="true"></div>
			<header
				className={cn("site-header", siteHeaderVariant, siteHeaderDivider)}
				data-sticky-root
			>
				<BlockGrid
					noVerticalSpacing={siteSettings?.headerNoVerticalSpacing ?? false}
					key={"header"}
					contentArea={headerBlocks ?? undefined}
					className="gap-0"
				/>
			</header>
		</>
	) : null;
}
